import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_021",
  "use": "icon-su_021-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-su_021\"><defs><style>#icon-su_021 .cls-1{fill:#ccccd0;}</style></defs><g id=\"icon-su_021_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_021_icon\"><path class=\"cls-1\" d=\"M8,1A7,7,0,1,1,1,8,7,7,0,0,1,8,1M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Z\" /><polygon class=\"cls-2\" points=\"8 11.41 3.29 6.71 4.71 5.29 8 8.59 11.29 5.29 12.71 6.71 8 11.41\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol